import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TotalStopsIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function TotalStopsIcon({
  color = RoutalPalette.secondary60,
  style = {},
  ...props
}: TotalStopsIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 14 13" style={{ height: `14px`, width: `14px`, fill: `none`, ...style }}>
      <g>
        <path
          d="M7.28101 1C5.95492 1 4.68315 1.45155 3.74547 2.25531C2.80779 3.05908 2.28101 4.14921 2.28101 5.28591C2.28101 9.28895 6.78101 12.7477 6.95101 12.8934C7.04225 12.9621 7.15955 13 7.28101 13C7.40246 13 7.51976 12.9621 7.61101 12.8934C7.80601 12.7477 12.281 9.28895 12.281 5.28591C12.281 4.72307 12.1517 4.16575 11.9004 3.64576C11.6491 3.12577 11.2808 2.6533 10.8165 2.25531C10.3522 1.85733 9.80105 1.54163 9.19442 1.32625C8.58779 1.11086 7.93762 1 7.28101 1ZM7.28101 11.9805C6.28101 11.1233 3.28101 8.30747 3.28101 5.28591C3.28101 4.37655 3.70243 3.50444 4.45258 2.86143C5.20272 2.21842 6.22014 1.85718 7.28101 1.85718C8.34187 1.85718 9.35929 2.21842 10.1094 2.86143C10.8596 3.50444 11.281 4.37655 11.281 5.28591C11.281 8.28604 8.28101 11.1105 7.28101 11.9805Z"
          fill={color}
        />
        <path
          d="M3.88417 8.70386C4.33187 9.52868 6.17002 11.5672 7.43229 12.4716C8.46774 11.8146 10.4123 9.55265 11.0011 8.77456C11.7372 7.80194 11.9274 5.99372 11.9274 4.40151C11.9274 3.14218 9.1983 1.36292 7.43229 1.36292C5.63977 1.36292 3.20405 3.09504 2.97685 4.40151C2.80306 5.40086 3.53915 8.0682 3.88417 8.70386Z"
          fill={color}
        />
        <path
          d="M5.10747 5.59026C6.24215 5.59026 7.16229 6.50243 7.16229 7.6273C7.22654 7.69667 7.33667 7.69667 7.39977 7.6273C7.39977 6.50243 8.31991 5.59026 9.45459 5.59026C9.52458 5.52656 9.52458 5.41738 9.45459 5.35482C8.31991 5.35482 7.39977 4.44265 7.39977 3.31778C7.33553 3.2484 7.22539 3.2484 7.16229 3.31778C7.16229 4.44265 6.24215 5.35482 5.10747 5.35482C5.03749 5.41851 5.03749 5.5277 5.10747 5.59026Z"
          fill={RoutalPalette.neutral00}
        />
        <path
          d="M1.80127 1.53262L12.0289 11.7603"
          stroke={RoutalPalette.neutral00}
          stroke-width="2"
          stroke-linecap="round"
        />
        <path d="M1.80127 1.53262L12.0289 11.7603" stroke={color} stroke-linecap="round" />
      </g>
    </SvgIcon>
  );
}
